export const LOGOUT = 'logout'
export const UPDATE_USER_ADDRESS = 'updateUserAddress'
export const UPDATE_USER_PROFILE = 'updateUserProfile'
export const GET_PROFILE = 'updateConnectedUser'
export const GET_INVOICES = 'getInvoices'
export const GET_RENTS = 'getRents'
export const GET_CARSHARINGS = 'getCarSharings'
export const GET_PARKS= 'getParks'
export const GET_COD_CONTRACTS = 'getCodContracts'
export const GET_REFILLS = 'getRefills'
export const GET_COUPONS = 'getCoupons'
export const GET_SUPPORTING_DOCUMENTS = 'getSupportingDocuments'
export const SEND_SUPPORTING_DOCUMENT = 'sendSupportingDocument'
export const ADD_COUPON = 'addCoupon'
export const SEND_DOWNLOAD_DATA_REQUEST = 'sendDownloadDataRequest'
export const GET_BRAZE_STATUS = 'getBrazeStatus'

export const UNSUBSCRIBE_NEWSLETTER = 'unsubscribeNewsletter'
export const SUBSCRIBE_NEWSLETTER = 'subscribeNewsletter'
